/**
 * Authentication Constants
 *
 * Centralized configuration for authentication behavior across all auth guards.
 */

/**
 * Maximum time (in milliseconds) to wait for authentication check before timing out.
 * If getCurrentUser() doesn't complete within this time, user is redirected to login.
 *
 * Default: 5000ms (5 seconds)
 */
export const AUTH_CHECK_TIMEOUT_MS = 5000;

/**
 * Number of retry attempts for authentication check on transient failures.
 * Helps handle temporary network hiccups without immediately logging out users.
 *
 * Default: 0 (no retry - fail fast for better UX)
 * Can be increased to 1 or 2 for production if needed
 */
export const AUTH_CHECK_RETRY_ATTEMPTS = 0;

/**
 * Delay (in milliseconds) between retry attempts.
 *
 * Default: 1000ms (1 second)
 */
export const AUTH_CHECK_RETRY_DELAY_MS = 1000;

/**
 * Session timeout reason codes for user-facing messages
 */
export enum SessionTimeoutReason {
  TIMEOUT = 'timeout',
  UNAUTHORIZED = 'unauthorized',
  NETWORK_ERROR = 'network_error'
}
